import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-busy", "role"];
const _hoisted_2 = {
  class: "loading-header"
};
const _hoisted_3 = {
  class: "loading-stage"
};
const _hoisted_4 = {
  class: "loading-orbit",
  "aria-hidden": "true"
};
const _hoisted_5 = {
  class: "orbit-core"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "loading-copy"
};
const _hoisted_9 = {
  class: "loading-index"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = {
  key: 3,
  class: "loading-progress",
  "aria-hidden": "true"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "loading-curtain"
  }, {
    default: _withCtx(() => [!_ctx.appStore.bootstrapReady ? (_openBlock(), _createElementBlock("section", {
      key: 0,
      class: _normalizeClass(["app-loading-overlay", {
        'is-error': _ctx.appStore.bootstrapFailed
      }]),
      "aria-busy": !_ctx.appStore.bootstrapFailed,
      role: _ctx.appStore.bootstrapFailed ? 'alert' : 'status',
      "aria-live": "polite"
    }, [_cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "loading-grid",
      "aria-hidden": "true"
    }, null, -1)), _createElementVNode("header", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "Q / SYSTEM CONTEXT", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.appStore.bootstrapFailed ? 'CONNECTION INTERRUPTED' : 'ESTABLISHING'), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("span", {
      class: "orbit-ring orbit-ring--outer"
    }, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("span", {
      class: "orbit-ring orbit-ring--inner"
    }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("span", {
      class: "orbit-runner"
    }, null, -1)), _createElementVNode("span", _hoisted_5, [_ctx.appStore.site.logo ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: _ctx.appStore.site.logo,
      alt: ""
    }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(_ctx.appStore.brandMark || ''), 1))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.appStore.bootstrapFailed ? '00 — RETRY REQUIRED' : '01 — LOADING'), 1), _createElementVNode("h1", null, _toDisplayString(_ctx.appStore.bootstrapFailed ? '站点信息暂时无法载入' : _ctx.appStore.bootstrapLoading ? '正在建立站点上下文' : '正在同步站点信息'), 1), _ctx.appStore.bootstrapFailed ? (_openBlock(), _createElementBlock("p", _hoisted_10, "请检查网络或后端服务状态，恢复后重新建立连接。")) : (_openBlock(), _createElementBlock("p", _hoisted_11, "正在同步必要信息，页面将在准备完成后呈现。")), _ctx.appStore.bootstrapFailed ? (_openBlock(), _createElementBlock("button", {
      key: 2,
      class: "loading-retry",
      type: "button",
      disabled: _ctx.appStore.bootstrapLoading,
      onClick: _cache[0] || (_cache[0] = (...args) => $options.retryBootstrap && $options.retryBootstrap(...args))
    }, [...(_cache[5] || (_cache[5] = [_createTextVNode(" 重新连接 ", -1), _createElementVNode("span", {
      "aria-hidden": "true"
    }, "↗", -1)]))], 8, _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", null, null, -1)]))]))])]), _cache[8] || (_cache[8] = _createElementVNode("footer", {
      class: "loading-footer"
    }, [_createElementVNode("span", null, "CONTENT · COMMUNITY · SYSTEM"), _createElementVNode("span", null, "PLEASE STAND BY")], -1))], 10, _hoisted_1)) : _createCommentVNode("", true)]),
    _: 1
  });
}